import { render, staticRenderFns } from "./provider-landing.vue?vue&type=template&id=2632f403&scoped=true"
import script from "./provider-landing.vue?vue&type=script&lang=js"
export * from "./provider-landing.vue?vue&type=script&lang=js"
import style0 from "./provider-landing.vue?vue&type=style&index=0&id=2632f403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2632f403",
  null
  
)

export default component.exports